export default __webpack_public_path__ + "static/media/017.ca157132.jpg";